"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzIcon = _interopRequireDefault(require("./../OzIcon/OzIcon.js"));

var _consts = require("./../consts.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzCard__Wrapper",
  componentId: "sc-1o62cfe-0"
})(["\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  padding: 20px 30px;\n  ", ";\n\n  height: ", ";\n\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.variant === "default" ? "\n    background-color: #fff;\n    box-shadow: 0px 2px 16px #C1CCE838;\n  " : props.variant === "charcoal" ? "\n    background-color: " + _consts.CHARCOAL + ";\n    box-shadow: 0px 2px 16px #20283362;\n  " : null;
}, function (props) {
  return props.height;
});

var Header = _styledComponents.default.div.withConfig({
  displayName: "OzCard__Header",
  componentId: "sc-1o62cfe-1"
})(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", "px;\n  flex-grow: 0;\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 600;\n\n  ", "\n\n  ", ";\n\n"], function (props) {
  return props.isCollapsed ? 0 : 20;
}, function (props) {
  return props.hasSeparator ? "\n    padding-bottom: 10px;\n    border-bottom: 1px solid transparent;\n  " : null;
}, function (props) {
  return props.variant === "default" ? "\n    color: #303030;\n    border-color: #70707033;\n  " : props.variant === "charcoal" ? "\n    color: #ffffff;\n    border-color: #ffffff33;\n  " : null;
});

var HeaderLeft = _styledComponents.default.div.withConfig({
  displayName: "OzCard__HeaderLeft",
  componentId: "sc-1o62cfe-2"
})(["\n  padding-left: ", "px;\n  position: relative;\n"], function (props) {
  return props.collapsible ? 30 : 0;
});

var HeaderCenter = _styledComponents.default.div.withConfig({
  displayName: "OzCard__HeaderCenter",
  componentId: "sc-1o62cfe-3"
})(["\n  flex-grow: 1;\n  padding: 0px 20px;\n  text-align: center;\n"]);

var HeaderRight = _styledComponents.default.div.withConfig({
  displayName: "OzCard__HeaderRight",
  componentId: "sc-1o62cfe-4"
})(["\n"]);

var Body = _styledComponents.default.div.withConfig({
  displayName: "OzCard__Body",
  componentId: "sc-1o62cfe-5"
})(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  font-size: 12px;\n  font-weight: 400;\n\n  & hr{\n    border: 0px;\n    border-top: 1px solid transparent;\n    margin: 10px 0px;\n  }\n\n  ", ";\n"], function (props) {
  return props.variant === "default" ? "\n    color: #303030;\n    border-color: #70707033;\n  " : props.variant === "charcoal" ? "\n    color: #ffffff;\n    border-color: #ffffff33;\n  " : null;
});

var Footer = _styledComponents.default.div.withConfig({
  displayName: "OzCard__Footer",
  componentId: "sc-1o62cfe-6"
})(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  font-size: 12px;\n  font-weight: 400;\n\n  ", "\n\n  ", ";\n"], function (props) {
  return props.hasSeparator ? "\n    padding-top: 10px;\n    border-bottom: 1px solid transparent;\n  " : null;
}, function (props) {
  return props.variant === "default" ? "\n    color: #303030;\n    border-color: #70707033;\n  " : props.variant === "charcoal" ? "\n    color: #ffffff;\n    border-color: #ffffff33;\n  " : null;
});

var FooterLeft = _styledComponents.default.div.withConfig({
  displayName: "OzCard__FooterLeft",
  componentId: "sc-1o62cfe-7"
})(["\n"]);

var FooterCenter = _styledComponents.default.div.withConfig({
  displayName: "OzCard__FooterCenter",
  componentId: "sc-1o62cfe-8"
})(["\n  flex-grow: 1;\n  padding: 0px 20px;\n  text-align: center;\n"]);

var FooterRight = _styledComponents.default.div.withConfig({
  displayName: "OzCard__FooterRight",
  componentId: "sc-1o62cfe-9"
})(["\n"]);

var Toggle = _styledComponents.default.div.withConfig({
  displayName: "OzCard__Toggle",
  componentId: "sc-1o62cfe-10"
})(["\n  position: absolute;\n  top: calc(50% - 10px);\n  left: 0px;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  transform: rotate(", "deg);\n  transition: all 0.25s ease-in-out;\n  cursor: pointer;\n"], function (props) {
  return props.isCollapsed ? -90 : 0;
});

var OzCard = function OzCard(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "auto" : _ref$height,
      _ref$headerLeft = _ref.headerLeft,
      headerLeft = _ref$headerLeft === void 0 ? null : _ref$headerLeft,
      _ref$headerCenter = _ref.headerCenter,
      headerCenter = _ref$headerCenter === void 0 ? null : _ref$headerCenter,
      _ref$headerRight = _ref.headerRight,
      headerRight = _ref$headerRight === void 0 ? null : _ref$headerRight,
      _ref$headerLeftCollap = _ref.headerLeftCollapsed,
      headerLeftCollapsed = _ref$headerLeftCollap === void 0 ? headerLeft : _ref$headerLeftCollap,
      _ref$headerCenterColl = _ref.headerCenterCollapsed,
      headerCenterCollapsed = _ref$headerCenterColl === void 0 ? headerCenter : _ref$headerCenterColl,
      _ref$headerRightColla = _ref.headerRightCollapsed,
      headerRightCollapsed = _ref$headerRightColla === void 0 ? headerRight : _ref$headerRightColla,
      _ref$footerLeft = _ref.footerLeft,
      footerLeft = _ref$footerLeft === void 0 ? null : _ref$footerLeft,
      _ref$footerCenter = _ref.footerCenter,
      footerCenter = _ref$footerCenter === void 0 ? null : _ref$footerCenter,
      _ref$footerRight = _ref.footerRight,
      footerRight = _ref$footerRight === void 0 ? null : _ref$footerRight,
      _ref$headerSeparator = _ref.headerSeparator,
      headerSeparator = _ref$headerSeparator === void 0 ? false : _ref$headerSeparator,
      _ref$footerSeparator = _ref.footerSeparator,
      footerSeparator = _ref$footerSeparator === void 0 ? false : _ref$footerSeparator,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
      children = _ref.children;

  var _useState = (0, _react.useState)(collapsed),
      isCollapsed = _useState[0],
      setCollapsed = _useState[1];

  var iconColor = _consts.BLACKPEARL;

  switch (variant) {
    case "charcoal":
      iconColor = "#FFFFFF";
      break;

    default:
      break;
  }

  return __jsx(Wrapper, {
    height: height,
    variant: variant
  }, headerLeft || headerRight ? __jsx(Header, {
    variant: variant,
    hasSeparator: !collapsible || !isCollapsed ? headerSeparator : false,
    isCollapsed: isCollapsed
  }, __jsx(HeaderLeft, {
    collapsible: collapsible
  }, collapsible ? __jsx(Toggle, {
    onClick: function onClick() {
      return setCollapsed(!isCollapsed);
    },
    isCollapsed: isCollapsed
  }, __jsx(_OzIcon.default, {
    name: "arrow-down",
    color: iconColor
  })) : null, isCollapsed ? headerLeftCollapsed : headerLeft), headerCenter || isCollapsed && headerCenterCollapsed ? __jsx(HeaderCenter, null, isCollapsed ? headerCenterCollapsed : headerCenter) : null, __jsx(HeaderRight, null, isCollapsed ? headerRightCollapsed : headerRight)) : null, !isCollapsed ? __jsx(_react.default.Fragment, null, __jsx(Body, {
    variant: variant
  }, children), footerLeft || footerRight ? __jsx(Footer, {
    variant: variant,
    hasSeparator: footerSeparator
  }, __jsx(FooterLeft, null, footerLeft), footerCenter ? __jsx(FooterCenter, null, footerCenter) : null, __jsx(FooterRight, null, footerRight)) : null) : null);
};

var _default = OzCard;
exports.default = _default;